<template>
	<div>
		<header>
			<img src="../assets/logo.svg">
			<router-link to="/"><div class="subtitle">
			<span>{{brandName}}</span>
			<span>  >  </span>
			</div></router-link>
		</header>

		  <div class="content" :style="height">
			<iframe :src="link"></iframe>
			<div class="seclect">
				<h2>TA distribution in Shanghai</h2>
        <div class="brand">
            <div class="brandImg"><img :src="imgUrl" width="100" height="100" style="background:#000;border: 1px solid #e5e5e5;"></div>
            <div class="text">
              <p>{{age}}</p>
              <p></p>
              <p>上海市区有{{people}}符合您要求的目标人群 <span>You have {{people}} TA in urban areas of Shanghai.</span> </p>
            </div>
        </div>
			</div>


		</div>
      <footer>
        <div>
         <div class="prev"><router-link to="/select"> << prev </router-link></div>
         <div class="step"><span>1/4</span></div>
         <div class="continue"><span><router-link to="/second2"><button clickMusic='true'>Continue</button></router-link></span></div>
        </div>
      </footer>
	</div>

</template>
<style type="text/css">
</style>

<script>
import link from '../assets/link';

export default {
   name:"second",
   data(){
   	return{
   		msg:"第二页",
   		brandName:"",
   		imgUrl:'',
   		link:'',
   		people:"",
   		age:'',
   		height:{
   			height:""
   		},

   	}
   },
   methods:{

   	  readData(){
   	  	this.brandName = sessionStorage.getItem("BrandName");
   	  	this.showLink();
   	  },
       showLink(){
   	      for(let a of link.brand){
   	          if(a.name == this.brandName){
   	             this.link=a.link[0];
   	             this.imgUrl = a.img;
   	             this.people= a.person[1]
   	             this.age= a.person[0]
              }
          }


       }

   },
    created() {
          console.log(window.innerHeight)
    	  this.height.height=window.innerHeight-120+'px';
      	  this.readData();
    },
    mounted() {

    }



}

</script>



// WEBPACK FOOTER //
// src/components/second.vue